// test1286
(1286 && 0);
